// extracted by mini-css-extract-plugin
export default {"card_actions_padding":"12px","card_actions_space_between":"16px"};